module.exports = __webpack_public_path__ + "static/Lamia-8fc3e4ebb41d59273bc8f8435d6a34f4.jpg";